/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Grid, Typography, Button, DialogContent, DialogActions, Dialog, DialogTitle,
} from '@material-ui/core';
import {
  AssignmentInd,
} from '@material-ui/icons';
import '../../shared/arial';
import MaterialTable from 'material-table';
import Moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { Loading, exportXlsx } from '../../helpers/utils';
import groupServices from '../../redux/services/groupServices';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import teacherServices from '../../redux/services/teacherServices';
import { toastError, toastSuccess } from '../../redux/actions/alertActions';
import SelectExaminer from '../Exams/SelectExaminer';
import ClientBill from '../Exams/ClientBill';
import TeacherBill from '../Exams/TeacherBill';
import NumberOfStudents from '../Exams/NumberOfStudents';
import ExamUpdate from '../Exams/ExamUpdate';

const getFormatedDate = (time) => `${time >= 60 ? `${Math.floor(time / 60)}h ` : ''} ${time % 60 > 0 ? `${Math.round(time % 60)}min` : ''}`;

async function getGroupsWithExamByCompany(id) {
  const groups = await groupServices.getAllGroupsWithExamByCompany(id);
  return groups;
}

const findGroupLv2 = (groupLv1, groups) => {
  let res = null;
  groups.forEach((group) => {
    if (res === null && group.examBegin === groupLv1.examBegin && group.examType === groupLv1.examType && group.examActivityId === groupLv1.examActivityId && group.examEnd === groupLv1.examEnd && group.examSubjectId === groupLv1.examSubjectId && group.examName === groupLv1.examName && group.examModality === groupLv1.examModality) {
      res = group;
    }
  });
  return (res);
};

const dates = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
}));

const ExamList = ({ examData, setExamData, company }) => {
  const refTable = useRef();

  const [selectedExamData, setSelectedExamData] = useState();
  const [loadingState, setLoadingState] = useState(true);
  const [examDataLv2, setExamDataLv2] = useState([]);
  const [allTeachers, setAllTeachers] = useState([]);
  const [modal, setModal] = useState(false);

  const classes = useStyles();

  const getDateFormated = (_date) => {
    const date = Moment(_date);
    const day = date.date();
    const month = dates[date.month()];
    const year = date.year();
    const hours = date.hours();
    const minutes = date.minutes();

    return `${day} ${month} ${year} - ${hours}h${minutes < 10 && minutes > 0 ? '0' : ''}${minutes > 0 ? minutes : ''}`;
  };

  const getDateFormatedDay = (_date) => {
    const date = Moment(_date);
    const day = date.date();
    const month = date.month() + 1;
    const year = date.year();

    return `${day}/${month}/${year}`;
  };

  const getDateFormatedHour = (_date) => {
    const date = Moment(_date);
    const hours = date.hours();
    const minutes = date.minutes();

    return `${hours}h${minutes < 10 && minutes > 0 ? '0' : ''}${minutes > 0 ? minutes : ''}`;
  };

  const getGap = (date1, date2) => {
    const dateDiff = date2 - date1;
    const diffMins = Math.round(dateDiff / 60 / 1000); // minutes
    let hoursDiff = Math.round((diffMins - (diffMins % 60)) / 60);
    const daysDiff = hoursDiff / 24;
    hoursDiff %= 24;
    return `${
      daysDiff > 1 ? `${Math.round(daysDiff)}j ` : ''
    }${hoursDiff}h ${diffMins % 60 < 10 && diffMins % 60 > 0 ? '0' : ''}${
      diffMins % 60 > 0 ? `${diffMins % 60}min` : ''
    }`;
  };

  const updateCompanies = () => {
    setLoadingState(true);
    const formatedArray = [];
    const formatedArrayLv2 = [];
    getGroupsWithExamByCompany(company._id)
      .then((groups) => {
        if (groups.length > 0) {
          groups.forEach((group) => {
            if (group.elearning?.elearningOptions !== undefined && group.level === 1 && group.elearning?.elearningOptions !== null) {
              group.elearning.elearningOptions.forEach((option) => {
                const { examBegin } = option;
                const { examEnd } = option;
                formatedArray.push({
                  examId: option._id,
                  name: group.name,
                  catchUp: option.catchUp,
                  groupId: group._id,
                  nbStudents: group.listIdUsers
                    ? group.listIdUsers.length
                    : 0,
                  students: group.listIdUsers,
                  examBegin,
                  examEnd,
                  examName: option.examSubject ? option.examSubject.name : null,
                  examType: option.examSubject ? option.examSubject.type : null,
                  examActivityId: option.examSubject ? option.examSubject.activityId : null,
                  examFile: option.examSubject ? option.examSubject.examFile : null,
                  examSubjectId: option.examSubject ? option.examSubject._id : null,
                  duration: getGap(
                    Moment(examBegin),
                    Moment(examEnd),
                  ),
                  durations: option.duration,
                  examiner: option.examiner,
                  semester: group.semester,
                  EWCorrect: option.EWCorrect,
                  examModality: option.modality ? option.modality : null,
                  status: option.status,
                  results: option.results,
                  clientBill: option.clientBill,
                  teacherBill: option.teacherBill,
                  nbPapers: option.nbPapers,
                });
              });
            } else if (group.elearning?.elearningOptions !== undefined && group.level === 2 && group.elearning?.elearningOptions !== null) {
              group.elearning.elearningOptions.forEach((option) => {
                const { examBegin } = option;
                const { examEnd } = option;
                formatedArrayLv2.push({
                  examId: option._id,
                  name: group.name,
                  catchUp: option.catchUp,
                  groupId: group._id,
                  nbStudents: group.listIdUsers
                    ? group.listIdUsers.length
                    : 0,
                  students: group.listIdUsers,
                  examBegin,
                  examEnd,
                  examName: option.examSubject ? option.examSubject.name : null,
                  examType: option.examSubject ? option.examSubject.type : null,
                  examActivityId: option.examSubject ? option.examSubject.activityId : null,
                  examFile: option.examSubject ? option.examSubject.examFile : null,
                  examSubjectId: option.examSubject ? option.examSubject._id : null,
                  duration: getGap(
                    Moment(examBegin),
                    Moment(examEnd),
                  ),
                  durations: option.duration,
                  examiner: option.examiner,
                  semester: group.semester,
                  EWCorrect: option.EWCorrect,
                  examModality: option.modality ? option.modality : null,
                  status: option.status,
                  results: option.results,
                  clientBill: option.clientBill,
                  teacherBill: option.teacherBill,
                  nbPapers: option.nbPapers,
                });
              });
            }
          });
        }
        setExamData(formatedArray);
        setExamDataLv2(formatedArrayLv2);
        teacherServices.getTeachers()
          .then((res) => {
            setAllTeachers(res);
            setLoadingState(false);
          });
      });
  };

  const handleStatus = (groupId, examId) => {
    groupServices.getGroupWithExam(groupId)
      .then((res) => {
        const elearningDetails = res.elearning;

        elearningDetails.elearningOptions.forEach((option) => {
          if (option._id === examId) {
            option.status.name = 'To be picked up';
            option.status.updatedAt = Date.now();
          }
        });

        elearningDetailsServices.updateElearningDetails(elearningDetails._id, elearningDetails)
          .then((elearningDetail) => {
            if (elearningDetail !== undefined) {
              toastSuccess('Statut mis à jour');
            } else {
              toastError('La mise à jour du statut n\'a pas pu s\'effectuer');
            }
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(async () => {
    setLoadingState(true);
    updateCompanies();
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MaterialTable
            title="Exams"
            columns={[
              {
                title: 'Results',
                field: 'results',
                cellStyle: {
                  paddingLeft: '25px',
                },
                headerStyle: {
                  paddingLeft: '25px',
                },
                render: (rowData) => (
                  <Link
                    to={{
                      pathname: '/results',
                      state: {
                        exam: rowData,
                        exam2: findGroupLv2(rowData, examDataLv2),
                        redirectPath: `/company/exports/${company._id}`,
                      },
                    }}
                  >
                    <AssignmentInd />
                  </Link>
                ),
              },
              {
                title: 'Groupe',
                field: 'name',
                render: (rowData) => `Semester ${rowData.semester}${rowData.catchUp === true ? ' - Rattrapage' : ''}`,
              },
              {
                title: 'Début',
                field: 'examBegin',
                defaultSort: 'desc',
                render: (rowData) => getDateFormated(rowData.examBegin),
              },
              {
                title: 'Fin',
                field: 'examEnd',
                render: (rowData) => getDateFormated(rowData.examEnd),
                hidden: true,
                hiddenByColumnsButton: true,
                width: '10%',
              },
              {
                title: 'Durée',
                field: 'durations',
                hidden: true,
                hiddenByColumnsButton: true,
                width: '10%',
                render: (rowData) => {
                  if (rowData.durations) {
                    return getFormatedDate(rowData.durations);
                  }
                  return rowData.duration;
                },
              },
              {
                title: 'Etudiants',
                field: 'nbStudents',
                width: '10%',
                hidden: true,
                hiddenByColumnsButton: true,
              },
              {
                title: 'Nombre de copies',
                field: 'nbPapers',
                width: '10%',
                hidden: true,
                hiddenByColumnsButton: true,
                render: (rowData) => {
                  if (rowData.EWCorrect) {
                    return <NumberOfStudents data={rowData} />;
                  }
                  return <Typography variant="caption" style={{ color: '#8f8f8f' }}>Non corrigé par EW</Typography>;
                },
              },
              {
                title: 'Modalité',
                field: 'examModality',
                width: '10%',
                hidden: true,
                hiddenByColumnsButton: true,
                render: (rowData) => {
                  if (rowData.examModality !== null) {
                    if (rowData.examModality !== 'Quiz automatisé') {
                      return <Typography variant="caption" style={{ color: '#000000' }}>{rowData.examModality}</Typography>;
                    }
                    return (
                      <Typography variant="caption" style={{ color: '#000000' }}>
                        {rowData.examModality}
                        {` - ${getFormatedDate(rowData.durations || 90)}`}
                      </Typography>
                    );
                  }
                  return <Typography variant="caption" style={{ color: '#8f8f8f' }}>Pas de modalité</Typography>;
                },
              },
              {
                title: 'Sujet',
                field: 'examName',
                hidden: true,
                hiddenByColumnsButton: true,
                width: '10%',
                render: (rowData) => (
                  <>
                    {rowData.examName !== null
                      ? <Typography variant="caption" style={{ color: '#000000' }}>{rowData.examName}</Typography>
                      : <Typography variant="caption" style={{ color: '#8f8f8f' }}>Pas de sujet</Typography>}
                  </>
                ),
              },
              {
                title: 'Corrigé par',
                field: 'examiner',
                render: (rowData) => (
                  <>
                    {rowData.EWCorrect && allTeachers && allTeachers.length > 0
                      ? <SelectExaminer rowData={rowData} examDataLv2={examDataLv2} teachers={allTeachers} />
                      : <Typography variant="caption" style={{ color: '#8f8f8f' }}>Non corrigé par EW</Typography>}
                  </>
                ),
              },
              {
                title: 'Statut des copies',
                field: 'status',
                width: '10%',
                render: (rowData) => (
                  <>
                    {(rowData.status !== undefined && rowData.EWCorrect)
                      ? (rowData.status.name !== null
                        ? <Alert severity="info">{rowData.status.name}</Alert>
                        : (rowData.examFile === 'Sur table'
                          ? (
                            <Button
                              variant="contained"
                              style={{ fontSize: '11px' }}
                              onClick={() => handleStatus(rowData.groupId, rowData.examId)}
                            >
                              Copies prêtes à être récupérées
                            </Button>
                          )
                          : <Typography variant="caption" style={{ color: '#8f8f8f' }}>En attente</Typography>
                        ))
                      : <Typography variant="caption" style={{ color: '#8f8f8f' }}>Pas de statut</Typography>}
                  </>
                ),
              },
              {
                title: 'Facture formateur',
                field: 'teacherBill',
                cellStyle: {
                  minWidth: 200,
                  maxWidth: 200,
                },
                render: (rowData) => {
                  if (rowData.EWCorrect) {
                    let teacherBill = '';
                    if (rowData.teacherBill !== undefined) {
                      teacherBill = rowData.teacherBill;
                    }
                    return <TeacherBill examDataLv2={examDataLv2} examDataLv1={rowData} teacherBillProps={teacherBill} />;
                  }
                  return <Typography variant="caption" style={{ color: '#8f8f8f' }}>Pas de facture</Typography>;
                },
              },
              {
                title: 'Facture client',
                field: 'clientBill',
                cellStyle: {
                  minWidth: 200,
                  maxWidth: 200,
                },
                render: (rowData) => {
                  if (rowData.EWCorrect) {
                    let clientBill = '';
                    if (rowData.clientBill !== undefined) {
                      clientBill = rowData.clientBill;
                    }
                    return <ClientBill examDataLv2={examDataLv2} clientBillProps={clientBill} examDataLv1={rowData} />;
                  }
                  return <Typography variant="caption" style={{ color: '#8f8f8f' }}>Pas de facture</Typography>;
                },
              },
            ]}
            isLoading={loadingState}
            components={{
              OverlayLoading: () => <Loading />,
            }}
            localization={{
              body: {
                emptyDataSourceMessage: loadingState
                  ? ''
                  : 'No records to display',
                editRow: {
                  deleteText:
                    'Etes-vous sûr de vouloir supprimer cet examen ?',
                },
              },
              toolbar: {
                exportCSVName: 'Export as Excel',
              },
            }}
            actions={[
              {
                icon: 'edit',
                tooltip: 'modifier exam',
                onClick: (event, rowData) => {
                  setSelectedExamData(rowData);
                  setModal(true);
                },
              },
            ]}
            editable={{
              onRowDelete: (oldData) => (new Promise((resolve, reject) => {
                groupServices
                  .getGroupWithExam(oldData.groupId)
                  .then((res) => {
                    const elearningDetails = res.elearning;
                    elearningDetails.elearningOptions = elearningDetails.elearningOptions.filter((option) => option._id !== oldData.examId);
                    elearningDetailsServices.updateElearningDetails(
                      elearningDetails._id,
                      elearningDetails,
                    )
                      .then(() => {
                        toastSuccess('Examen supprimé');
                        const examsArr = [...examData];
                        examsArr.forEach((exam, index) => {
                          if (exam.examId === oldData.examId) {
                            examsArr.splice(index, 1);
                          }
                        });
                        setExamData(examsArr);
                        resolve();
                      })
                      .catch(() => {
                        toastError('Echec de la suppression');
                        reject();
                      });
                  });
              })),
            }}
            tableRef={refTable}
            data={examData}
            options={{
              columnsButton: true,
              search: true,
              pageSize: 10,
              exportButton: true,
              exportCsv: (columns, data) => {
                teacherServices.getTeachers()
                  .then((teachersInBdd) => {
                    data.map(async (item) => {
                      delete item.companyId;
                      delete item.groupId;
                      delete item.tableData;
                      delete item.examId;
                      delete item.examActivityId;
                      delete item.results;
                      delete item.examType;
                      delete item.students;
                      let teachers = '';
                      if (item.examiner !== undefined && item.examiner.length > 0 && teachersInBdd.length > 0) {
                        item.examiner.forEach((teacher) => {
                          teachersInBdd.forEach((elem) => {
                            if (elem._id === teacher) {
                              teachers += `${elem.name} ${elem.firstname}, `;
                            }
                          });
                        });
                      }
                      item.examiner = teachers;
                      item.status = item.status.name ? item.status.name : 'No status';
                      item.examBeginHour = getDateFormatedHour(item.examBegin);
                      item.examBegin = getDateFormatedDay(item.examBegin);
                      item.examEnd = getDateFormated(item.examEnd);
                      return item;
                    });
                    exportXlsx(data, 'list_of_exams');
                  });
              },
              exportAllData: true,
              sorting: true,
              rowStyle: (rowData) => ({
                borderStyle: 'solid',
                borderWidth: '0px',
                borderLeftWidth: '12px',
                borderRightWidth: '12px',
                borderLeftColor:
                  Moment(rowData.examBegin) >= new Date()
                    ? '#bcf4ce'
                    : Moment(rowData.examEnd) >= new Date()
                      ? '#f5e1af'
                      : '#fff',
                borderRightColor:
                  Moment(rowData.examBegin) >= new Date()
                    ? '#bcf4ce'
                    : Moment(rowData.examEnd) >= new Date()
                      ? '#f5e1af'
                      : '#fff',
              }),
            }}
          />
        </Grid>
      </Grid>
      <Dialog
        open={modal}
        onClose={() => setModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Mise à jour exam
        </DialogTitle>
        <DialogContent>
          { selectedExamData
            ? (
              <ExamUpdate
                data={selectedExamData}
                closeModal={() => setModal(false)}
                examData={examData}
                examDataLv2={examDataLv2}
                setExamData={setExamData}
              />
            )
            : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModal(false)} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ExamList.propTypes = {
  // handleEditExam: PropTypes.func.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedNotificatiion = connect(mapState)(ExamList);
export default injectIntl(connectedNotificatiion);
